import { ICustomerPlatform } from "@/interfaces/customer-platform.interfaces";

export type CustomerPlatformWithActiveAlias = ICustomerPlatform & { active?: boolean };

/**
 * Indica se o vínculo customerplatform está ativo para uso (conversas, envio, etc.).
 * A API pode enviar `active` (camelCase) ou `Active` (já normalizado em getCustomerPlatforms).
 */
export function isCustomerPlatformBindingActive(cp: CustomerPlatformWithActiveAlias): boolean {
  const raw = (cp.Active ?? cp.active) as unknown;
  if (raw === false || raw === 0 || raw === "0") return false;
  if (typeof raw === "string" && raw.toLowerCase() === "false") return false;
  return true;
}
